// extracted by mini-css-extract-plugin
export default {"gallery":"style_gallery__F+I3B","image":"style_image__nP11U","text":"style_text__j9xiS"};